export default {
  getItem: (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch {
      console.log("Failed to write on localstorage");
    }
  },
  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch {
      console.log("Failed to remove on localstorage");
    }
  },
  type: () => {
    try {
      return typeof localStorage !== "undefined";
    } catch {
      return "undefined";
    }
  },
};
